import formatCurrency from 'utils/format-currency';
import formatDateTime from 'utils/format-date-time';
import formatDate from 'utils/format-date';
import formatString from 'utils/format-string';

export default {
  install(Vue) {
    Vue.filter('formatCurrency', formatCurrency);
    Vue.filter('formatDateTime', formatDateTime);
    Vue.filter('formatDate', formatDate);
    Vue.filter('capitalize', formatString.capitalize);
  },
};
